'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { I18NContext } from '../context/context';
export const I18NProvider = ({ data, children }) => (_jsx(I18NContext.Provider, { value: data, children: children }));
